import { useEffect, useRef } from "react";
import { CAPTCHA_PROVIDER, CAPTCHA_SITE_KEY } from "@/services/config";
import { ensureCaptchaLoaded, getTurnstileGlobal, setTurnstileToken } from "@/services/captcha";

/**
 * Renders the Cloudflare Turnstile widget when Turnstile is configured. For
 * reCAPTCHA v3 nothing is rendered (the token is fetched invisibly at submit
 * time). When no captcha is configured it renders nothing, so forms are
 * unchanged out of the box.
 */
export default function CaptchaWidget() {
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (CAPTCHA_PROVIDER !== "turnstile" || !CAPTCHA_SITE_KEY) return;

    let cancelled = false;

    ensureCaptchaLoaded().then((loaded) => {
      if (!loaded || cancelled || !container.current) return;
      const turnstile = getTurnstileGlobal();
      if (!turnstile) return;
      turnstile.render(container.current, {
        sitekey: CAPTCHA_SITE_KEY,
        theme: "light",
        callback: (token) => setTurnstileToken(token),
        "error-callback": () => setTurnstileToken(""),
        "expired-callback": () => setTurnstileToken(""),
      });
    });

    return () => {
      cancelled = true;
    };
  }, []);

  if (CAPTCHA_PROVIDER !== "turnstile" || !CAPTCHA_SITE_KEY) return null;

  return <div ref={container} className="mt-1" />;
}